export default __webpack_public_path__ + "static/media/Sun-gold.78c6f11e.svg";